import { Box } from '@mui/material';

interface PreventInteractionOverlayProps {
  active: boolean;
}

const PreventInteractionOverlay: React.FC<PreventInteractionOverlayProps> = ({ active }) => {
  if (!active) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '99',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderRadius: '4px'
      }}
    />
  );
};

export default PreventInteractionOverlay;
